module.exports = __webpack_public_path__ + "static/media/19.d5ee656d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/19.png
// module id = 1349
// module chunks = 0